<template>
  <div>
    <div ref="blackBox" class="blackBox"></div>
    <transition mode="out-in" @appear="rvEnter" @leave="rvLeave" @enter="rvEnter">
      <slot></slot>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BlackBoxLoader",
  methods: {
    rvEnter: function(el, done) {
      this.$anime
        .timeline({
          easing: "easeOutSine",
          duration: 1200,
          targets: this.$refs.blackBox
        })
        .add({
          translateY: [0, "100%"]
        })
        .add(
          {
            targets: el.childNodes,
            translateY: ["100%", 0],
            delay: this.$anime.stagger(200, { form: "center" }),
            complete: done
          },
          0
        );
      /* console.log(el); */
    },
    rvLeave: function(el, done) {
      this.$anime
        .timeline({
          easing: "easeInOutQuad",
          duration: 1000,
          targets: this.$refs.blackBox
        })
        .add({
          targets: el.childNodes,
          translateY: [0, "-100%"]
        })
        .add(
          {
            translateY: ["-100%", 0],
            complete: done
          },
          0
        );
    }
  }
};
</script>

<style scoped lang="scss">
.blackBox {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: $darkPrimary;
  z-index: 10;
}
</style>
